import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const HeadingOne = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <path d="M11.2988 10.9902V12.2559H6.81055V10.9902H11.2988ZM7.25 7.46875V16H5.63867V7.46875H7.25ZM12.4941 7.46875V16H10.8828V7.46875H12.4941ZM17.9199 7.44531V16H16.3672V9.25586L14.3105 9.93555V8.68164L17.7441 7.44531H17.9199Z" />
  </SvgIcon>
));

export default React.memo(HeadingOne);
